document.addEventListener('DOMContentLoaded', function () {
  const wrapper = document.querySelector('.quantity-discount');
  if (!wrapper) return;

  const radios = wrapper.querySelectorAll('.quantity-discount__radio');
  const items = wrapper.querySelectorAll('.quantity-discount__item');

  const form = document.querySelector('form[data-type="add-to-cart-form"]');
  if (!form) {
    console.error('quantity-discount-selector: could not find the add-to-cart form');
    return;
  }

  const quantityInput = form.querySelector('input[name="quantity"]');
  if (!quantityInput) {
    console.error('quantity-discount-selector: could not find input[name="quantity"] in the form');
    return;
  }

  radios.forEach((radio) => {
    radio.addEventListener('change', function () {
      if (!radio.checked) return;

      quantityInput.value = radio.dataset.quantity;

      items.forEach((item) => item.classList.remove('quantity-discount__item--selected'));
      radio.closest('.quantity-discount__item').classList.add('quantity-discount__item--selected');
    });
  });
});